module.exports = __webpack_public_path__ + "assets/images/JMDC5.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/JMDC5.png
// module id = 1401
// module chunks = 1